import { render, staticRenderFns } from "./PresentationProjet.vue?vue&type=template&id=4cf27c2b&"
import script from "./PresentationProjet.vue?vue&type=script&lang=js&"
export * from "./PresentationProjet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports